var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M8 1.435a6.565 6.565 0 1 1 0 13.13 6.565 6.565 0 0 1 0-13.13Zm0 .014A6.55 6.55 0 1 0 8 14.55a6.55 6.55 0 0 0 0-13.1ZM8 10.9a.3.3 0 1 1 0 .6.3.3 0 0 1 0-.6Zm0-6.32c1.273 0 2.22.97 2.22 2.087 0 .898-.568 1.34-1.109 1.669-.104.063-.194.115-.278.164a4 4 0 0 0-.446.286 1 1 0 0 0-.222.23l-.003.003v.001l-.074.12-.001.141c0 .047-.04.086-.087.086a.087.087 0 0 1-.087-.087c0-.271.157-.467.367-.63a5 5 0 0 1 .545-.347c.067-.04.136-.079.196-.116.258-.156.52-.337.712-.58.208-.264.314-.573.314-.94 0-1.014-.863-1.913-2.047-1.913s-2.047.899-2.047 1.913a.087.087 0 0 1-.087.087.087.087 0 0 1-.086-.087C5.78 5.55 6.727 4.58 8 4.58Z"
  })));
};
export default SvgQuestionMark;